import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActionCompletion, Actions, ofActionCompleted, Select, Store} from '@ngxs/store';
import {Observable, Subject} from 'rxjs';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {takeUntil} from 'rxjs/operators';
import ResponseHandlingHelper from '../../helpers/response-handling-helper';
import {QuoteModelResponse} from '../../api/responses/quote-response';
import {QuotesState} from '../../states/quotes.state';
import {FetchQuote} from '../../states/quotes.actions';
import {PushMenuActiveAccountId} from 'src/app/states/menu.actions';
import {HttpErrorCode} from 'src/app/api/http-error-code.enum';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-quote-page',
  templateUrl: './quote-page.component.html',
  styleUrls: ['./quote-page.component.scss']
})
export class QuotePageComponent implements OnInit, OnDestroy {

    public accountId: number;

    public now = Date.now() / 1000;

    @Select(QuotesState.quote)
    public quoteListener: Observable<QuoteModelResponse | null>;

    public quote: QuoteModelResponse | null = null;

    public quoteNo: string;

    private gc = new Subject();

    /**
     * Określa czy aktualnie trwa pobieranie danych.
     */
    public isLoading = false;

    /**
     * Token służący do anulowania pobierania danych.
     */
    private cancellationToken = new Subject();

    constructor(
        private store: Store,
        private actions: Actions,
        private router: Router,
        private route: ActivatedRoute,
        private title: Title
    ) {
    }

    public ngOnInit() {
        this.title.setTitle('Quote - Dataedo Account');
        this.initEvents();
    }

    private initEvents() {
        this.route.params
            .pipe(takeUntil(this.gc))
            .subscribe(params => this.onPathChange(params));

        this.quoteListener
            .pipe(takeUntil(this.gc))
            .subscribe(quote => this.quote = quote);

        this.actions
            .pipe(ofActionCompleted(FetchQuote))
            .pipe(takeUntil(this.gc))
            .subscribe(event => this.onCompletedFetchQuote(event));
    }

    private onPathChange(params: Params) {
        this.accountId = parseInt(params.accountId, 10);
        this.store.dispatch(new PushMenuActiveAccountId(this.accountId));

        this.quoteNo = params.quoteNo.replace('-', '/');
        this.fetchData();
    }

    private fetchData() {
        this.isLoading = true;

        this.cancellationToken.next();
        this.store.dispatch(new FetchQuote(this.accountId, this.quoteNo, this.cancellationToken));
    }

    private async onCompletedFetchQuote(event: ActionCompletion<FetchQuote, Error>) {
        const response = ResponseHandlingHelper.parse(event.result);
        if (response.isError && response.error.status === HttpErrorCode.Forbidden) {
            await this.router.navigate(['/accounts', this.accountId]);
        }

        this.isLoading = false;
    }

    public ngOnDestroy(): void {
        this.cancellationToken.next();
        this.cancellationToken.complete();

        this.gc.next();
        this.gc.complete();
    }

}
